import comp from "./Tooltip";
export default comp;
